import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createQuickActionsApi = (db: MarlinStoreDb) => ({
  getQuickActions: () => ops.getQuickActions(db),
  saveQuickAction: (action: Parameters<typeof ops.saveQuickAction>[1]) =>
    ops.saveQuickAction(db, action),
  updateQuickAction: (
    id: Parameters<typeof ops.updateQuickAction>[1],
    updates: Parameters<typeof ops.updateQuickAction>[2],
  ) => ops.updateQuickAction(db, id, updates),
  deleteQuickAction: (id: Parameters<typeof ops.deleteQuickAction>[1]) =>
    ops.deleteQuickAction(db, id),
  getActiveExecutions: () => ops.getActiveExecutions(db),
  createActiveExecution: (
    actionId: Parameters<typeof ops.createActiveExecution>[1],
    messageId: Parameters<typeof ops.createActiveExecution>[2],
    machineId: Parameters<typeof ops.createActiveExecution>[3],
  ) => ops.createActiveExecution(db, actionId, messageId, machineId),
  updateActiveExecutions: (
    machineId: Parameters<typeof ops.updateActiveExecutions>[1],
    messageId: Parameters<typeof ops.updateActiveExecutions>[2],
    executionStatus: Parameters<typeof ops.updateActiveExecutions>[3],
  ) => ops.updateActiveExecutions(db, machineId, messageId, executionStatus),
  clearActiveExecution: (
    actionId: Parameters<typeof ops.clearActiveExecution>[1],
  ) => ops.clearActiveExecution(db, actionId),
});

export type QuickActionsApi = ReturnType<typeof createQuickActionsApi>;
